import { StackProps, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material"
import React, { useState } from "react"
import { CenteredBox, Stack } from "src/shared/components"
import BorderStack from "src/shared/components/border-stack"
import OutlinedInput from "src/shared/components/outlined-input"

const denominationList = [1, 2, 5, 10, 20, 50, 100, 500, 1000, 5000]
type DenominationType = {
  multiplier: number | null
  denominate: number
  value: number
}
const Denomination = ({ currency, ...rest }: { currency?: string } & StackProps) => {
  const [denominations, setDenominations] = useState<DenominationType[]>(
    denominationList.map((val) => ({ multiplier: 0, denominate: val, value: 0 }))
  )
  const total = denominations.reduce((acc, val) => acc + (val.value ?? 0), 0)
  return (
    <BorderStack {...rest}>
      <CenteredBox>
        <Table sx={{ width: "auto", borderCollapse: "collapse" }}>
          <TableBody>
            {denominationList.map((val) => (
              <DenominationRow
                denomination={denominations.find((denom) => denom.denominate === val) as DenominationType}
                setDenominations={setDenominations}
                denominate={val}
                currency={currency}
              />
            ))}
          </TableBody>
        </Table>
        <Stack direction={"row"} justifyContent={"space-between"} spacing={2}>
          <Typography variant="body1" fontWeight={600}>
            Total
          </Typography>
          <Typography variant="body1" fontWeight={600}>
            =
          </Typography>
          <Typography variant="body1" fontWeight={600}>
            {total}
          </Typography>
        </Stack>
      </CenteredBox>
    </BorderStack>
  )
}

export default Denomination

const DenominationRow = ({
  currency,
  denominate,
  denomination,
  setDenominations
}: {
  currency?: string
  denominate: number
  denomination: DenominationType
  setDenominations: React.Dispatch<React.SetStateAction<DenominationType[]>>
}) => {
  return (
    <>
      <TableRow>
        <TableCell sx={{ paddingLeft: "12px" }}>
          <Typography variant="body2" textAlign={"right"}>
            {/* {currency} */}
            {denominate}
          </Typography>
        </TableCell>
        <TableCell>
          <Stack direction={"row"} alignItems={"center"} justifyContent={"center"} spacing={2}>
            <Typography variant="body2">X</Typography>
            <OutlinedInput
              value={denomination.multiplier}
              onChange={(e) =>
                setDenominations((prev) =>
                  prev.map((denom) =>
                    denom.denominate === denominate
                      ? {
                          ...denom,
                          multiplier: e.target.value ? Number(e.target.value) : null,
                          value: denom.denominate * Number(e.target.value ?? "0")
                        }
                      : denom
                  )
                )
              }
              type="number"
              className="numberinput"
              placeholder="0"
              sx={{ width: "100px" }}
            />
            <Typography variant="body2">=</Typography>
          </Stack>
        </TableCell>
        <TableCell style={{ paddingLeft: "12px", textAlign: "right" }}>
          <Typography variant="body2">
            {currency} {denomination.value}
          </Typography>
        </TableCell>
      </TableRow>
    </>
  )
}
